import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import { GlobalService } from 'src/app/services/global.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-addtopcolleges',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './addtopcolleges.component.html',
  styleUrls: ['./addtopcolleges.component.scss'],
})
export class AddtopcollegesComponent implements OnInit {
  display: any = 'none';
  displayDelete: any = 'none';
  category: any;
  subject: any;
  document: any;
  cources: any[];
  courseData: any;
  showAdd = false;
  showEdit = false;
  id: any;

  courseForm: UntypedFormGroup;

  showErr = false;
  deleteErr: any;

  searchval: any;

  error_messages = {
    collegeval: [{ type: 'required', message: 'Please Enter College Name' }],
  };
  adminName: any;
  adminImage: any;
  allCourse: any;
  allData: any;

  showData = false;
  showNodata = false;

  @ViewChild('boxCourse', { static: false }) boxCourse: ElementRef;
  images: any;
  imageTrueFalse: boolean;
  imageForm: any;
  logo = [];
  image: any = [];
  allImages: any;
  allCollegeImages: any;
  displayimages: any = 'none';
  addtopcollegeImage: any = [];
  addtopcollegeImageID: any;
  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.courseForm = this.formBuilder.group({
      collegeval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      colglogoImg: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      colgImg: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;
    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  ngOnInit(): void {
    this.spinner.show();
    this.courseForm.reset();
    this.getcollegeimage();
    // Get All Courses \\
    const servicePathDistrict = this.utils.getApiConfigs('course');
    this.commonservice
      .invokeService(
        servicePathDistrict[1].method,
        servicePathDistrict[1].path,
        ''
      )
      .then((resp: any) => {
        // console.log("Course", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.courseData = resp.data;

          if (this.courseData == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        }
        this.allCourse = this.courseData;
      });
  }

  topcollegeImage() {
    this.spinner.show();
    let payload = {
      trending_college_id: this.addtopcollegeImageID,
      image: this.addtopcollegeImage,
    };
    console.log('payload', payload);
    const servicePath = this.utils.getApiConfigs('addtopimage');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        console.log('addtopresponse----------', resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.addtopcollegeImage = [];
          this.spinner.hide();
          this.onCloseHandledimage();
          this.globalService.showSuccess('Image Add Successfully');
          this.display = 'none';
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
        }
      });
  }

  handleFileInput1(event) {
    // console.log("event", event.target.files);

    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;

      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.image.push(event.target.result);

          console.log(this.image);
          this.imageTrueFalse = true;
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }
  deleteImage(imageId) {
    this.spinner.show();
    let payload = {
      id: imageId,
    };
    const servicePath = this.utils.getApiConfigs('topcolimagedelete');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.globalService.showSuccess('Image Delete Successfully');
          this.display = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
        }
      });
  }
  openAdd1(index, data) {
    this.courseForm.reset();
    this.displayimages = 'block';
    this.showAdd = true;
    this.showEdit = false;
    this.addtopcollegeImageID = this.allCollegeImages[index].id;
    console.log('imageId---------------', data);
  }

  onCloseHandledimage() {
    this.displayimages = 'none';
    this.showAdd = false;
    this.showEdit = false;
  }
  deleteallimage(index) {
    this.spinner.show();
    this.allCollegeImages[index].image;
    let payload = {
      id: this.allCollegeImages[index].id,
    };
    console.log('payload', payload);
    const servicePath = this.utils.getApiConfigs('topcolimagedeleteall');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.allCollegeImages[index].image = [];
          this.allCollegeImages[index].image.lessData = [];
          this.spinner.hide();
          this.globalService.showSuccess('All Image Delete Successfully');
          this.display = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
        }
      });
  }

  getcollegeimage() {
    this.spinner.show();
    const servicePathImages = this.utils.getApiConfigs('trendingcolleges');
    // // console.log("servicePathCollege",servicePathImages);
    this.commonservice
      .invokeService(servicePathImages[0].method, servicePathImages[0].path, '')
      // const servicePath = this.utils.getApiConfigs('trendingcolleges');
      // this.commonservice.invokeService(servicePath[0].method, servicePath[0].path,"")
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.allImages = resp.data;
          console.log('All Images', this.allImages);

          if (this.allImages == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
        }
        this.allCollegeImages = this.allImages;

        console.log('All colleges', this.allCollegeImages);

        for (let i = 0; i < this.allCollegeImages.length; i++) {
          // this.clgImages = this.allCollegeImages[i];
          this.allCollegeImages[i].lessData = this.allCollegeImages[
            i
          ].image.slice(0, 4);
          // console.log("clgimages", this.allCollegeImages[i]);

          // for(let j=0; j<= this.clgImages.length; j++){
          //   this.imageData = this.clgImages[j].images;
          //   console.log("imgs", this.imageData);
          // }
        }
      });
  }

  viewImages(index) {
    // console.log(index);
    if (!this.allCollegeImages[index].isShowAll) {
      this.allCollegeImages[index].lessData =
        this.allCollegeImages[index].image;
    } else {
      this.allCollegeImages[index].lessData = this.allCollegeImages[
        index
      ].image.slice(0, 4);
    }
    this.allCollegeImages[index].isShowAll =
      !this.allCollegeImages[index].isShowAll;
  }

  onMouseOver(e) {
    (<HTMLDivElement>this.boxCourse.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boxCourse.nativeElement).style.cursor = 'pointer';
  }

  onChangeEvent(event) {
    // console.log("event", event);

    var val = event.target.value;
    // console.log("val", val);

    this.allData = this.courseData;

    // console.log("All Data", this.allData);

    if (val) {
      this.allCourse = this.allData.filter((item) =>
        item.courses.toLowerCase().includes(val.toLowerCase())
      );
    }

    // console.log("Courses Data", this.allCourse);
    if (this.allCourse == '') {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  // addCourse(){
  //   this.spinner.show();
  //   let payload = {
  //     "courses": this.courseName,
  //   }
  //   // console.log("payload", payload);
  //   const servicePath = this.utils.getApiConfigs('course');
  //   this.commonservice.invokeService(servicePath[0].method, servicePath[0].path, payload)
  //     .then((resp: any) => {
  //       // console.log("resp", resp);
  //       this.spinner.hide();
  //       if (resp.status_code == "200") {
  //         this.spinner.hide();
  //         // console.log(resp);
  //         this.globalService.showSuccess("Course added Successfully");
  //         this.display = "none";
  //         this.ngOnInit();
  //         this.courseForm.reset();
  //       }else if(resp.status_code == "400"){
  //         this.spinner.hide();
  //         this.globalService.showError(resp.data);
  //         this.display = "none";
  //         // console.log("data", resp.data);
  //       }
  //     });
  // }

  openAdd() {
    this.courseForm.reset();
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }
  // handleFileInput(event) {
  //   // console.log("event", event.target.files);

  //   if (event.target.files && event.target.files[0]) {
  //     var filesAmount = event.target.files.length;

  //     for (let i = 0; i < filesAmount; i++) {
  //       var reader = new FileReader();
  //       reader.onload = (event: any) => {

  //         this.image.push(event.target.result);
  //         this.imageTrueFalse = true;
  //       }
  //       reader.readAsDataURL(event.target.files[i]);
  //     }
  //   }
  // }
  handleFileInput(event) {
    // console.log("event", event.target.files);

    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;

      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.image.push(event.target.result);
          this.addtopcollegeImage.push(event.target.result);

          console.log(this.image);
          this.imageTrueFalse = true;
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  handleFileInputlogo(event) {
    // console.log("event", event.target.files);

    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;

      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.logo.push(event.target.result);
          console.log(this.logo);
          this.imageTrueFalse = true;
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  // handleFileInpulogo(event) {
  //   // console.log("event", event.target.files);

  //   // const file = event.target.files[0];
  //   // const reader = new FileReader();
  //   // reader.readAsDataURL(file);
  //   // reader.onload = () => {
  //   // let logo = reader.result
  //   // this.logo.push(logo)
  //   //     console.log(reader.result);
  //   // };

  //       // var reader = new FileReader();
  //       // reader.onload = (event: any) => {

  //       //   this.logo.push(event.target.result);
  //       //   console.log("asasasas",this.logo)
  //       //   this.imageTrueFalse = true;
  //       // }
  //       // reader.readAsDataURL(event.target.files);
  //       if (event.target.files && event.target.files[0]) {
  //         var filesAmount = event.target.files.length;

  //         for (let i = 0; i < filesAmount; i++) {
  //           var reader = new FileReader();
  //           reader.onload = (event: any) => {

  //             this.images.push(event.target.result);
  //             console.log(this.images)
  //             this.imageTrueFalse = true;
  //           }
  //           reader.readAsDataURL(event.target.files[i]);
  //         }
  //       }

  // }

  addtopcImages() {
    this.spinner.show();
    let payload = {
      college_name: this.document,
      logo: this.logo,
      image: this.image,
    };
    console.log('payload', payload);
    const servicePath = this.utils.getApiConfigs('trendingcollege');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          // console.log(resp);
          this.spinner.hide();
          this.globalService.showSuccess('Image Added Successfully');
          this.display = 'none';
          this.ngOnInit();
          this.courseForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  // editCourse(data){
  //   // console.log("Data", data);
  //   this.display = "block";
  //   this.showAdd = false;
  //   this.showEdit = true;

  //   this.courseName = data.courses;
  //   this.id = data.id;
  // }

  deleteCourse(data) {
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  // updateCourse(){
  //   this.spinner.show();
  //   let payload = {
  //     "courses": this.courseName,
  //     "id": this.id
  //   }
  //   // console.log("payload", payload);
  //   const servicePath = this.utils.getApiConfigs('course');
  //   this.commonservice.invokeService(servicePath[0].method, servicePath[0].path, payload)
  //     .then((resp: any) => {
  //       // console.log("resp", resp);
  //       this.spinner.hide();
  //       if (resp.status_code == "200") {
  //         this.spinner.hide();
  //         // console.log(resp);
  //         this.globalService.showSuccess("Course updated successfully");
  //         this.display = "none";
  //         this.ngOnInit();
  //         this.courseForm.reset();
  //       }else if(resp.status_code == "400"){
  //         this.spinner.hide();
  //         // console.log("data", resp.data);
  //         this.globalService.showError(resp.data);
  //         this.display = "none";
  //       }
  //     });
  // }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletecourses');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Course deleted successfully');
          this.displayDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.showErr = true;
          this.deleteErr = resp.message;
        }
      });
  }
}
